type BrandBadgeProps = {
  compact?: boolean;
};

export function BrandBadge({ compact = false }: BrandBadgeProps) {
  return (
    <div className={compact ? "brand-badge brand-badge--compact" : "brand-badge"}>
      <img src="/brand/mydigigovsa-logo.png" alt="myDigiGovSA" />
    </div>
  );
}
